import { ComponentRef, Injectable } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { RouteTitleService } from 'src/app/shared/route-title.service';
import { AuthenticationService } from '../shared/authentication/auth.service';
import { ApolloInitService } from './apollo-init.service';
import { NavigationService } from './navigation.service';

export function bootstrapApp(appBootstrapper: AppBootstrapService) {
  return (componentRef: ComponentRef<any>) => {
    if (componentRef.instance instanceof AppComponent) {
      appBootstrapper.init();
    }
  };
}

@Injectable({
  providedIn: 'root',
})
export class AppBootstrapService {
  constructor(
    private _apollo: ApolloInitService,
    private _routeTitles: RouteTitleService,
    private _nav: NavigationService,
    private _auth: AuthenticationService,
  ) {}

  public async init(): Promise<any> {
    this._apollo.init();
    this._auth.init();
    this._routeTitles.init();
    this._nav.init();
  }
}
